module.exports = __webpack_public_path__ + "img/175.b376ced4.jpg";